import React, { useState, useEffect, useRef, useCallback, useImperativeHandle, forwardRef } from "react";
import { useSignal, useSlot } from 'react-signal-slot'
import { Tree } from 'primereact/tree';
import Fetcher from "../Common/Fetch";
import 'rc-slider/assets/index.css';
import classNames from 'classnames';

interface CategoryShortInfo {
    key: number,
    label: string,
    data: any,
    icon: string,
    children: []
}

interface IPropsType {
    CategoryId: Array<number>
}

function TreeCategories(props: IPropsType) {

    // состояние для открытия/скрытия фильтра
    const [isOpen, setIsOpen] = useState(false);

    const signalSelectCategory = useSignal();
    // данное свойство заполнятеся запросом с сервера и получает в себя дерево категорий
    const [subCategories, setSubCategories] = useState<CategoryShortInfo[]>([]);

    // данное свойство относится к дереву категорий и храит текущий выделенный элемент
    const [expandedKeys, setExpandedKeys] = useState([]);
    const [activeNodeKey, setActiveNodeKey] = useState(props.CategoryId);

    // некоторый флаг необходимоый нам для единоразового вызова метода, получающего информацию о эцп пользователя
    const [isFirstLoad, setIsFirstLoad] = useState(true);

    const [selectedCats, setSelectedCats] = useState([]);
    const [parentCats, setParentCats] = useState({});

    // маленький hook метод который отработает у нас всего доин раз для получения эцп пользователя
    useEffect(() => {
        if (isFirstLoad) {
            Fetcher("/Category/GetTreeCategories", {}).then(value => value.json())
                .then((result) => {
                    setSubCategories(result);
                }
           );
        }
    }, [isFirstLoad]);


    useEffect(() => {
        signalSelectCategory('categoryChange', selectedCats);
    }, [selectedCats]);

    const cc = (cat) => {
        return (
            cat.map(i => {
                return (i.children ? getCats(i)
                    :  <div className="catLink"
                            onClick={() => {
                                if (selectedCats.includes(i.key)) {
                                    let updated = selectedCats.filter(k => k !== i.key);

                                    Object.entries(parentCats).forEach(([parent, children]) => {
                                        if (children.includes(i.key)) {
                                            const stillActive = children.some(child => updated.includes(child));
                                            if (!stillActive && updated.includes(Number(parent))) {
                                                updated = updated.filter(k => k !== Number(parent));
                                            }
                                        }
                                    });

                                    setSelectedCats(updated);
                                } else {
                                    const newSelected = [...selectedCats, i.key];

                                    Object.entries(parentCats).forEach(([parent, children]) => {
                                        if (children.includes(i.key)) {
                                            const allSelected = children.every(child => newSelected.includes(child));
                                            if (allSelected && !newSelected.includes(Number(parent))) {
                                                newSelected.push(Number(parent));
                                            }
                                        }
                                    });

                                    setSelectedCats(newSelected);
                                }
                            }}
                        >
                            <div
                                key={i.key}
                                className={selectedCats.includes(i.key) ? "checkbox active" : "checkbox"}
                            ></div>
                            {i.label}
                        </div>)
            })
        )
    }

    const getAllKeys = (node) => {
        let keys = [node.key];
        if (node.children && node.children.length > 0) {
            node.children.forEach(child => {
                keys = [...keys, ...getAllKeys(child)];
            });
        }
        return keys;
    };

    const setAllParentCats = (cat) => {
        let keys = {};

        if (cat.children && cat.children.length > 0) {
            keys[cat.key] = cat.children.map(child => child.key);

            cat.children.forEach(child => {
                const childKeys = setAllParentCats(child);
                keys = { ...keys, ...childKeys };
            });
        }

        return keys;
    };

    useEffect(() => {
        if (subCategories) {
            let allParents = {};
            subCategories.forEach(cat => {
                allParents = { ...allParents, ...setAllParentCats(cat) };
            });
            setParentCats(allParents);
        }
    }, [subCategories]);

    const deselectEmptyParents = (updatedSelected, childKey) => {
        Object.entries(parentCats).forEach(([parentKey, childKeys]) => {
            if (childKeys.includes(childKey)) {
                const stillActive = childKeys.some(k => updatedSelected.includes(k));

                if (!stillActive && updatedSelected.includes(Number(parentKey))) {
                    updatedSelected = updatedSelected.filter(k => k !== Number(parentKey));
                    updatedSelected = deselectEmptyParents(updatedSelected, Number(parentKey));
                }
            }
        });

        return updatedSelected;
    };

    const getCats = (cats) => {
        return (
            <div className={selectedCats.includes(cats.key) ? "parent active" : "parent"}>
                <div className="parentCat">
                    <div
                        className={selectedCats.includes(cats.key) ? "checkbox active" : "checkbox"}
                        onClick={(e) => {
                            if (selectedCats.includes(cats.key)) {
                                const allKeys = getAllKeys(cats);
                                let updated = selectedCats.filter(i => !allKeys.includes(i));

                                updated = deselectEmptyParents(updated, cats.key);

                                setSelectedCats(updated);
                            } else {
                                const allKeys = getAllKeys(cats);
                                setSelectedCats(prev => [...new Set([...prev, ...allKeys])]);
                            }
                        }}
                    ></div>
                    <p
                        onClick={(e) => {
                            if (selectedCats.includes(cats.key)) {
                                const allKeys = getAllKeys(cats);
                                let updated = selectedCats.filter(i => !allKeys.includes(i));

                                updated = deselectEmptyParents(updated, cats.key);

                                setSelectedCats(updated);
                            } else {
                                const allKeys = getAllKeys(cats);
                                setSelectedCats(prev => [...new Set([...prev, ...allKeys])]);
                            }
                        }}
                    >{cats.label}</p>
                    {cats.children &&
                        <img src="/main-images/categoryFilterArrow.svg"
                            onClick={(e) => { e.currentTarget.parentElement.parentElement.classList.toggle("active") }}
                        ></img>
                    }
                </div>
                {cats.children &&
                    <div className="list">
                        {cc(cats.children)}
                    </div>
                }
            </div>
        )
    }

    return (
        <React.Fragment>
            <h5 className="sidebar-title" onClick={() => { setIsOpen(!isOpen) }}>Подкатегории <img src="/main-images/categoryFilterArrow.svg"></img></h5>
            <div className="subCategoriesTree filterTree" style={{ display: isOpen ? 'flex' : 'none' }}>
                {subCategories.map(i => 
                    <div className="catWrap">
                        {getCats(i)}
                    </div>
                )}

            </div>
        </React.Fragment>
    );
}

export default TreeCategories;